export enum OpcoesBrf {
	BRF_A = 1,
	BRF_B = 2,
	BRF_C = 3,
	BRF_Spot = 4,
	BRF_OTM = 5,
	BRF_inelegivel = 6,
}

export const opcoesBrfMapper = [
	{ label: "BRF A", value: OpcoesBrf.BRF_A },
	{ label: "BRF B", value: OpcoesBrf.BRF_B },
	{ label: "BRF C", value: OpcoesBrf.BRF_C },
	{ label: "BRF Spot", value: OpcoesBrf.BRF_Spot },
	{ label: "BRF Otm", value: OpcoesBrf.BRF_OTM },
	{ label: "BRF Inelegível", value: OpcoesBrf.BRF_inelegivel },
];
